import React from 'react'
import './offers.css'
import {
    Box, 
    Container, 
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography
} from '@mui/material';
import {CiDiscount1} from 'react-icons/ci';
import {FaSuitcase} from 'react-icons/fa';
import {GiRollingSuitcase} from 'react-icons/gi';
export default function Offers() {
  return (
    <Container>
        <List className='Offers'>
            <Box
            display='flex'>
                <ListItem disablePadding sx={{width:'200px'}}>
                    <ListItemButton>
                    <ListItemIcon>
                        <div className='faded'>
                            <CiDiscount1 style={{fontWeight:'bold', fontSize:'30px', position:'relative', right:'5px', bottom:'5px'}} fill='white'/>
                        </div>
                    </ListItemIcon>
                    <ListItemText primary={<Typography variant='h6' color='white' fontSize='12px' fontWeight='bold'>Super Offers<Typography variant='body2' fontSize='10px'>Explore great deals && offers</Typography></Typography>} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{width:'200px'}}>
                    <ListItemButton>
                    <ListItemIcon>
                        <div>
                            <FaSuitcase style={{fontWeight:'bold', fontSize:'30px', position:'relative', right:'5px', bottom:'5px'}} fill='orange'/>
                        </div>
                    </ListItemIcon>
                    <ListItemText primary={<Typography variant='h6' color='white' fontSize='12px' fontWeight='bold'>Introducing My Biz<Typography variant='body2' fontSize='10px'>Buisness travel solution</Typography></Typography>} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{width:'200px'}}>
                    <ListItemButton>
                    <ListItemIcon>
                        <div>
                            <GiRollingSuitcase style={{fontWeight:'bold', fontSize:'30px', position:'relative', right:'5px', bottom:'5px'}} fill='goldenrod'/>
                        </div>
                    </ListItemIcon>
                    <ListItemText primary={<Typography variant='h6' color='white' fontSize='12px' fontWeight='bold'>My Trips<Typography variant='body2' fontSize='10px'>Manage your bookings</Typography></Typography>} />
                    </ListItemButton>
                </ListItem>
            </Box>
        </List>
    </Container>
  )
}
